export enum BlankSideEnum {
  FRONT = "FRONT",
  BACK = "BACK",
  FRONT_BACK = "FRONT_BACK",
}

export enum BlankSingleSideEnum {
  FRONT = BlankSideEnum.FRONT,
  BACK = BlankSideEnum.BACK,
}

export enum BlankGenderEnum {
  MASCULINO = "MASCULINO",
  FEMININO = "FEMININO",
  INFANTIL = "INFANTIL",
}

export enum ProductLineEnum {
  CASUAL = "Casual",
  ESPORTIVO = "Esportivo",
}

export type CanvasTransformation = {
  position: { x: number; y: number };
  scale: { x: number; y: number };
  rotation: number;
};

export interface PrintArea {
  x: number;
  y: number;
  w: number;
  h: number;
}

/**
 * @description Interface representando dados de imagem de blank FORMATADOS pelo frontend - propriedade `showSide` convertida de numérico para string.
 * @see formatBlanksDataFromApi para conversão de dados da API
 */
export interface BlankImageData {
  id: string;
  colorHex: string;
  colorName: string;
  showSide: BlankSingleSideEnum;
  customizationPrice: number;
  imageSrc: string;
  imageSrc2?: string | null;
  printArea: PrintArea;
  printSize: { w: number; h: number };
  mainImage: boolean;
}

/**
 * @description Interface representando dados de produto blank FORMATADOS pelo frontend com informações preprocessadas.
 * @see formatBlanksDataFromApi para conversão de dados da API
 */
export interface BlankProductData {
  id: string;
  name: string;
  description: string;

  model: string;
  family: string;
  gender: BlankGenderEnum;

  price: number;
  /** Preço mínimo de venda (apenas para contexto de loja) */
  minSellingPrices: { oneSide: number; twoSides: number } | null;
  baseCosts: { oneSide: number; twoSides: number } | null;
  /** Detalhes da ficha técnica */
  tecnicalDetails: string[];
  images: (Omit<BlankImageData, "showSide"> & { showSide: BlankSideEnum })[];

  //Informações preprocessadas
  imageSrc: string;
  imageSrc2?: string | null;
  colors: string[];
  sizes: string[];
}

export interface BlankTextData extends CanvasTransformation {
  fontFamily: string;
  fontSize: number;
  isBold: boolean;
  isItalic: boolean;
  isUnderlined: boolean;
  align: string;
  color: string;
  content: string[];
}

export interface IBlankStock {
  id: string;
  title: string;
  stock: Record<string, number>;
}

export enum ApiBlankFaceEnum {
  FRONT = 1,
  BACK = 2,
  FRONT_BACK = 3,
}

export interface ApiBlank extends Omit<BlankProductData, "name" | "gender" | "tecnicalDetails" | "images"> {
  title: string;
  public: BlankGenderEnum;
  technicalSheet: string[];
  realSize: { w: number; h: number };
  area: Record<ApiBlankFaceEnum, { w: number; h: number }> | null;
  images: (Omit<BlankImageData, "showSide" | "imageSrc" | "imageSrc2"> & {
    showFace: ApiBlankFaceEnum;
    customizationPrice: number;
    imageUrl: string;
    imageUrl2?: string | null;
  })[];
  /** Preço mínimo de venda (apenas para contexto de loja) */
  minSellingPrices: { oneSide: number; twoSides: number } | null;
  baseCosts: { oneSide: number; twoSides: number } | null;
}
